var React = require('react');

function SocialGithub (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C5.377 0 0 5.507 0 12.304c0 5.434 3.44 10.047 8.204 11.676.6.112.794-.265.794-.59v-2.296c-3.337.748-4.034-1.45-4.034-1.45-.542-1.423-1.33-1.8-1.33-1.8-1.09-.761.084-.748.084-.748 1.207.086 1.84 1.271 1.84 1.271 1.071 1.88 2.808 1.337 3.492 1.02.11-.795.42-1.338.762-1.649-2.666-.31-5.468-1.363-5.468-6.082 0-1.344.471-2.443 1.24-3.303-.123-.311-.536-1.562.116-3.257 0 0 1.007-.33 3.298 1.265.956-.272 1.982-.41 3.002-.417 1.02.006 2.046.139 3.008.417 2.292-1.589 3.299-1.265 3.299-1.265.652 1.695.245 2.946.116 3.257.768.86 1.233 1.959 1.233 3.303 0 4.725-2.808 5.765-5.48 6.069.432.384.826 1.132.826 2.277v3.375c0 .325.193.709.8.59C20.566 22.337 24 17.724 24 12.29 24 5.507 18.623 0 12 0z"}));
}

SocialGithub.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = SocialGithub;

SocialGithub.default = SocialGithub;
